import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Grid, Tab, MenuItem, Menu } from 'semantic-ui-react';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

import './index.scss';

const Integration = () => {
    const { id } = useParams();
    const { pathname } = useLocation();
    const end = pathname.split('/').pop();

    const root = `/settings/users/${id}/integration`;

    const navigate = useNavigate();

    const panes = [
        { path: '', menuItem: (
            <Menu.Item>
                Apps
            </Menu.Item>
    )},
        { path: 'email', menuItem: (
            <MenuItem>
                Email
            </MenuItem>
        )},
        { path: 'calendar', menuItem: (
            <MenuItem>
                Calendar
            </MenuItem>
        )},
        { path: 'web-launcher', menuItem: (
            <MenuItem>
                Web Launcher
            </MenuItem>
        )}
    ];

    const activeIndex = () => {
        return end === 'integration' ? 0 : panes.findIndex(({ path }) => path === end);
    }

    const onTabChange = (_, { activeIndex }) => {
        const path = panes[activeIndex].path;
        navigate(`${root}/${path}`);
    }

    return (
        <Grid className='IntegrationTab'>
            <Grid.Row>
                <Grid.Column>
                    <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW} type="hidden" userRestrict>
                        <Tab activeIndex={activeIndex()} onTabChange={onTabChange} menu={{ color: 'blue', secondary: true, pointing: true }} panes={panes}/>
                    </RestrictedView>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Outlet />
                </Grid.Column>
            </Grid.Row>

        </Grid>
    )
}

export default Integration;
